<template>
  <form id="destination_soroushplus_form">
    <b-tabs card>
      <b-tab no-body title="افزودن مقصد" active class="mt-2">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                افزودن مقصد
                {{ destinationNames.soroushplus }}
              </h3>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>نام</label>
              <input
                type="text"
                name="name"
                v-model="form.name"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>آدرس استریم‌</label>
              <input
                type="text"
                name="stream_url"
                dir="ltr"
                placeholder="Stream Url"
                v-model="form.details.stream_url"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>کلید استریم‌</label>
              <input
                type="text"
                name="stream_key"
                dir="ltr"
                placeholder="Stream Key"
                v-model="form.details.stream_key"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="rotation"
                  true-value="90"
                  false-value="0"
                  v-model="form.rotation"
                />
                <span class="mr-2"></span>
                چرخش ۹۰ درجه
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="proxy_status"
                  true-value="1"
                  false-value="2"
                  v-model="form.proxy_status"
                />
                <span class="mr-2"></span>
                استفاده از پروکسی
              </label>
            </div>
            <div class="form-group" v-if="isAdmin || isCompany">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="auto_connect"
                  true-value="1"
                  false-value="0"
                  v-model="form.auto_connect"
                />
                <span class="mr-2"></span>
                اتصال خودکار
              </label>
            </div>
            <div class="form-group" v-if="isAdmin || isCompany">
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  name="editable"
                  true-value="1"
                  false-value="0"
                  v-model="form.editable"
                />
                <span class="mr-2"></span>
                فابلیت وبرایش و حدف توسط کاربر
              </label>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab no-body title="آموزش" class="mt-2"> </b-tab>
    </b-tabs>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

export default {
  name: "CrSoroushDestination",
  props: {
    isCompany: Boolean,
    isAdmin: Boolean
  },
  data() {
    return {
      form: {
        name: "",
        details: {
          // stream_url: "rtmp://rtmp.setakapp.ir:1935/events/",
          stream_url: "",
          stream_key: ""
        },
        rotation: "90",
        proxy_status: "2",
        auto_connect: "0",
        editable: "1"
      }
    };
  },
  mounted() {
    this.fv = formValidation(
      document.getElementById("destination_soroushplus_form"),
      {
        fields: {
          name: {
            validators: {
              notEmpty: {
                message: "نام صحیح نیست"
              },
              stringLength: {
                min: 2,
                max: 1000,
                message: "نام صحیح نیست"
              }
            }
          },
          stream_url: {
            validators: {
              notEmpty: {
                message: "آدرس استریم‌ الزامی است"
              },
              regexp: {
                regexp: /\w+:(\/?\/?)[^\s]+/,
                flags: "ig",
                message: "آدرس استریم‌ صحیح نیست"
              }
            }
          },
          stream_key: {
            validators: {
              notEmpty: {
                message: "کلید استریم‌ الزامی است"
              },
              stringLength: {
                min: 2,
                max: 1000,
                message: "کلید استریم‌ صحیح نیست"
              }
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      }
    );
  },
  computed: {
    ...mapGetters(["destinationNames"])
  }
};
</script>
